import { render, staticRenderFns } from "./dataIntellige.vue?vue&type=template&id=65157c88&scoped=true&"
import script from "./dataIntellige.vue?vue&type=script&lang=js&"
export * from "./dataIntellige.vue?vue&type=script&lang=js&"
import style0 from "./dataIntellige.vue?vue&type=style&index=0&id=65157c88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65157c88",
  null
  
)

component.options.__file = "dataIntellige.vue"
export default component.exports